<template>
  <div class="navbar">
    <div class="hamburger-container primary" @click="changeSidebar">
      <svg-img v-if="isCollapse" class-name="hamburger" icon-class="unfold" />
      <svg-img v-else class-name="hamburger" icon-class="fold" />
    </div>
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div class="right-menu">
      <el-dropdown
        class="theme-container primary"
        :class="{ 'primary-bg': enterTheme }"
        :style="enterTheme ? 'color: #fff' : ''"
      >
        <div
          class="theme-wrapper"
          @mouseenter="enterTheme = true"
          @mouseleave="enterTheme = false"
        >
          <svg-icon class-name="test-icon" icon-class="test" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <div
            v-for="item in themeInfo"
            :key="item.themeColor"
            @click="changeTheme(item.themeColor)"
          >
            <el-dropdown-item>
              <span
                style="width: 10px;height: 10px;display: inline-block"
                :style="{ background: '#' + item.themeColor }"
              ></span>
              {{ item.name }}
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        class="avatar-container primary"
        @visible-change="visibleChange"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span>欢迎光临！{{ userInfo.username }}</span>
          <i
            class="el-icon-arrow-down el-icon--right"
            :class="{ 'trans-icon': dialogVisible }"
          ></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div @click="open()">
            <el-dropdown-item>
              退出登录
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "./components/Breadcrumb";
import { logOut } from "@/utils/auth";

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      dialogVisible: false,
      enterTheme: false
    };
  },
  computed: {
    ...mapGetters(["isCollapse", "themeInfo", "theme", "userInfo"])
  },
  methods: {
    changeTheme(theme) {
      this.$store.commit("setTheme", theme);
    },
    changeSidebar() {
      this.$store.commit("changeSidebar");
    },
    open() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        logOut();
        location.reload();
      });
    },
    visibleChange(flag) {
      this.dialogVisible = flag;
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;

  .hamburger-container {
    height: 100%;
    display: flex;
    float: left;
    align-items: center;
    cursor: pointer;
    .hamburger {
      width: 18px;
      height: 18px;
    }
  }

  .breadcrumb-container {
    height: 100%;
    display: flex;
    float: left;
    align-items: center;
    margin-left: 20px;
  }

  .right-menu {
    float: right;
    display: flex;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .theme-container {
      height: 59px;
      width: 59px;
      margin-right: 10px;
      cursor: pointer;
      .theme-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
      }
    }

    .avatar-container {
      cursor: pointer;
      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }

        .el-icon--right {
          transition: all 0.2s;
        }
      }
    }
    .trans-icon {
      transform: rotate(180deg);
    }
  }
}
</style>
